module.exports = __webpack_public_path__ + "assets/img/dzh-18.6f1aaab6.jpg";